// This contains helper functions for matching references that a user is trying
// to refer to in the chat input.

// filterIncludes returns a list of references that include the string.
export const filterIncludes = (
    str: string,
    referenceList: Array<string>,
    limit: number,
): Array<string> => {
    if (str.length === 0 || referenceList.length === 0) {
        return referenceList.slice(0, limit);
    }

    const references = referenceList.filter((reference) => {
        return reference.toLowerCase().includes(str.toLowerCase());
    });

    return references.slice(0, limit);
};
